import React from "react";

import { Box, SxProps, Theme } from "@mui/material";
import { IgTypography } from "./IgTypography";
import {
  IgBasePrimitives,
  IgInteractiveBackgroundColors,
} from "@intelligems/ig-design-tokens/constants";

type IgBetaBadgeProps = {
  sx?: SxProps<Theme>;
  /**
   * `gradient` (the default) is the original dark-to-mid blue badge; `solid`
   * is Figma's "Nav Item/New Label": the accent fill with 10px semibold type,
   * used beside navigation items and in beta notices.
   */
  variant?: "gradient" | "solid";
};

export const IgBetaBadge = ({ sx, variant = "gradient" }: IgBetaBadgeProps) => {
  return (
    <Box
      sx={[
        {
          borderRadius: "4px",
          background:
            variant === "solid"
              ? IgInteractiveBackgroundColors.accent.default
              : `linear-gradient(90deg, ${IgBasePrimitives["900"]} 0%, ${IgBasePrimitives["600"]} 100%)`,
          padding: "2px 4px",
          height: "18px",
          display: "flex",
          ...(variant === "solid" && { flexShrink: 0 }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <IgTypography
        variant={"body3"}
        sx={{
          fontWeight: 600,
          color: "white",
          ...(variant === "solid" && { fontSize: "10px", lineHeight: 1.5 }),
        }}
      >
        BETA
      </IgTypography>
    </Box>
  );
};
